// extracted by mini-css-extract-plugin
module.exports = {"prettyNameAndAbbreviationEditor":"PrettyNameAndAbbreviationEditor_prettyNameAndAbbreviationEditor__nQc_I","text":"PrettyNameAndAbbreviationEditor_text__GfKl7"};